import styled from 'styled-components'
import { COLOR } from '../../../assets/constants/constants'

const { secondary, quaternary } = COLOR;

export const StyledMain = styled.div`
`;

export const AerialView = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  height: 20px;
  margin-bottom: 8px;
  font-family: 'Amorim Sans Book';
  font-size: 18px;
  color: ${secondary};
  transition: all .2s ease-out;
  cursor: pointer;
  &:hover {
    color: ${quaternary};
    svg {
      margin-right: 12px;
      color: ${quaternary};
    }
  }

  svg {
    width: 14px;
    margin-right: 10px;
    color: ${secondary};
    fill: ${secondary};
    transition: all .2s ease-out;

    &.drone-icon{
      width: 24px;
    }
  }
  
`


